import * as React from "react";
import "../theme.css";

export enum CoreTextType {
  header = "header",
  medium = "medium",
  mediumV2 = "mediumV2",
  largeV2 = "largeV2",
  large = "large",
  small = "small",
  smallV2 = "smallV2",
  smallv3 = "smallv3",
  big = "big",
}

export enum FontType {
  ubuntu = "'Ubuntu'",
  roboto = "'Roboto'",
}
export interface ITextProps {
  id?: string;
  as?: "div" | "span" | "h1" | "h2" | "h3" | "p";
  text?: string;
  type: CoreTextType;
  fontType?: FontType;
  color?: string;
  onClick?: Function;
  onChange?: (text: string) => void;
  contentEditable?: boolean;
  style?: React.CSSProperties;
}

const getStyle = (type: CoreTextType, color: string | undefined) => {
  if (type === (CoreTextType.smallv3))
    return {
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "19px",
      fontStyle: "normal",
    };
  if (type === (CoreTextType.smallV2))
    return {
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: 14,
      color: color ?? "var(--ui-text)",
    };
  if (type === (CoreTextType.mediumV2))
    return {
      color: color ?? "var(--ui-text)",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
    };
  if (type === (CoreTextType.largeV2))
    return {
      color: color ?? "var(--ui-text)",
      alignContent: "center",
      fontWeight: 500,
      fontSize: 50,
      // lineHeight: "20px",
    };
  if (type === (CoreTextType.small))
    return {
      color: color ?? "var(--ui-text)",
      fontSize: 12,
      fontWeight: 400,
      fontSizeAdjust: 14,
      textOverflow: "ellipsis",
    };

  if (type === (CoreTextType.large))
    return {
      color: color ?? "var(--ui-text)",
      fontSize: 16,
      fontWeight: 400,
      fontSizeAdjust: 14,
      textOverflow: "ellipsis",
    };
  if (type === (CoreTextType.medium))
    return {
      color: color ?? "var(--ui-text)",
      fontSize: 14,
      fontWeight: 400,
      textOverflow: "ellipsis",
      fontSizeAdjust: 14,
    };
  if (type === (CoreTextType.header))
    return {
      color: color ?? "var(--ui-text)",
      fontSize: 20,
      fontWeight: 500,
      textOverflow: "ellipsis",
      fontSizeAdjust: 16,
    };
  if (type === (CoreTextType.big))
    return {
      color: color ?? "var(--ui-text)",
      fontSize: 36,
      fontWeight: 600,
      textOverflow: "ellipsis",

      fontSizeAdjust: 16,
    };
  return {
    color: color ?? "var(--ui-text)",
    fontSize: 12,
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSizeAdjust: 14,
    textOverflow: "ellipsis",
  };
};

const appendStyle = (
  type: CoreTextType,
  color: string | undefined,
  style: React.CSSProperties | undefined,
  fontType: FontType | undefined
) => {
  let font = "var(--ui-font)";
  if (fontType !== undefined) {
    font = fontType;
  }
  return Object.assign(Object.assign(getStyle(type, color), style), {
    fontFamily: font,
  });
};
export function CoreText(props: ITextProps) {
  const Tag = props.as ?? "div";
  return (
    <Tag id={props.id}
      contentEditable={props.contentEditable}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}
      style={appendStyle(props.type, props.color, props.style, props.fontType)}
      onInput={(event) => {
        console.log(event);
        if (props.onChange) {
          // @ts-expect-error
          props.onChange(event.target.innerText);
        }
      }}
    >
      {props.text}
    </Tag>
  );
}
